
import { Metamodel } from '../base/model';
import { IModel } from '../base/annotation';

import { HubSpotLinkedService } from 'app/model/linkedservice/hub-spot.linkedservice';
import { TabularTypeDataset } from './tabular-type.dataset';
import { format } from 'app/shared/utils/string.util';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';

@Metamodel.model({
    name: adfModelTypeMap.hubspot.datasetType,
    display: [
        format(stringResources.ModelName_DatasetTemplate, stringResources.Hubspot_DisplayText),
        format(stringResources.ModelName_DatasetsTemplate, stringResources.Hubspot_DisplayText)
    ],
    constraints: {
        linkedService: {
            model: HubSpotLinkedService.MODEL // Linked service redefined
        }
    }
})
export class HubSpotObjectDataset extends TabularTypeDataset {
    public static readonly MODEL: IModel;

    public constructor(name?: string, description?: string) {
        super(name, description);
    }
}
